import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { BackgroundFormService } from 'src/app/services/background-form.service';

@Component({
  selector: 'app-background-form-adult',
  templateUrl: './background-form-adult.component.html',
  styleUrls: ['./background-form-adult.component.scss']
})
export class BackgroundFormAdultComponent implements OnInit {

  concernForm!:FormGroup
  answersForm!:FormGroup
  backgroundDetails:any={};
  answers:any
  isReadOnly:boolean=true
  token:any
  clientDetails:any=[]
  clientInfo: any;
  clientId:any
  appointmentId:any
  invalidToken:boolean=false
  currentDate = new Date();

  constructor(private spinner:NgxSpinnerService,private backgroundFormService:BackgroundFormService,private appointmentService:AppointmentService,private formBuilder:FormBuilder,private activatedRoute: ActivatedRoute) { 
    this.concernForm = this.formBuilder.group({
      concentrate: ['', Validators.required],
      distractions: ['', Validators.required],
      attention: ['', Validators.required],
      thinkBeforeAct: ['', Validators.required],
      waitForTurn: ['', Validators.required],
      startWithoutAsked: ['', Validators.required],
      completeTask: ['', Validators.required],
      organised: ['', Validators.required],
      trackOfTime: ['', Validators.required],
      rememberInstructions: ['', Validators.required],
      rememberRead: ['', Validators.required],
      controlEmotions: ['', Validators.required],
  });
  

    this.answersForm = this.formBuilder.group({
      interestInEval: ['', Validators.required],
      howIssuesImpacted: ['', Validators.required],
      learnFromAssesment: ['', Validators.required],
      medicalConditions: ['', Validators.required],
      performanceInSchool: ['', Validators.required],
      easySubjects: ['', Validators.required],
      challengingSubjects: ['', Validators.required],
  });
  }

  ngOnInit(): void {
    this.spinner.show()
    this.token= this.activatedRoute.snapshot.queryParamMap.get('token');
    this.backgroundFormService.validateTokenbackgroundForm(this.token).subscribe(res=>{
     this.clientDetails=res;
     this.clientInfo=this.clientDetails.data
     this.clientId=this.clientInfo.clientId
     this.appointmentId=this.clientInfo.appointmentId
      if(this.clientDetails.data.result=="Does not exists!!!"){
        this.invalidToken=true
      }
      this.spinner.hide()

    })
    this.answersForm = this.formBuilder.group({
      answer1: ['', Validators.required],
      answer2: ['', Validators.required],
      answer3: [''],
      answer4: ['', Validators.required],
      answer5: [''],
      answer6: ['', Validators.required],
      answer7: ['', Validators.required],
      answer8: ['', Validators.required],
      answer9: ['', Validators.required],
      answer10: ['', Validators.required],
      answer11: [''],
      answer12: ['', Validators.required],
      answer13: ['', Validators.required],
      answer14: ['', Validators.required],
      answer15: [''],
      answer16: ['', Validators.required],
      answer17: [''],
      dateOfBirth:['', Validators.required],
      currentSchool:['', Validators.required],
      backgroundFormComment: ['', Validators.required],
      concentrateWhenReading: ['', Validators.required],
      avoidDistractions: ['', Validators.required],
      payAttentionInBoringClass: ['', Validators.required],
      thinkBeforeAct: ['', Validators.required],
      waitForTurn: ['', Validators.required],
      startWithoutAsked: ['', Validators.required],
      completeTask: ['', Validators.required],
      stayOrganised: ['', Validators.required],
      keepTrackOfTime: ['', Validators.required],
      rememberInstructions: ['', Validators.required],
      rememberRead: ['', Validators.required],
      controlEmotions: ['', Validators.required],
      submitterName: ['', Validators.required],
  });
  }
  
  
   
  submit(){
    this.backgroundDetails['clientId']=this.clientId;
   this.backgroundDetails['appointmentId']= this.appointmentId
   this.backgroundDetails['backgroundDetails']=this.answersForm.value
   this.backgroundDetails['token']= this.token
   this.spinner.show()
  this.backgroundFormService.submitBackgroundFormDetails(this.backgroundDetails).subscribe(res=>{
    this.spinner.hide()
    location.reload();
  })
  
  }

  closeWindow(){
    window.close();
  }
 
  
  
  
  
}

